import React, {Component} from 'react';
import {Col, Grid, Row} from 'react-bootstrap';
import {Else, If, Then} from 'react-if';
import {toast} from 'react-toastify';
import {connect} from 'react-redux';
import FileDownload from 'react-file-download';
import BackLink from '../../../common/back-link';
import PageTitle from '../../../common/page-title';
import PushNotificationsTable from './push-notifications-table';
import Button from '../../../common/button';
import {downloadPushNotifications, getPushNotifications} from '../../../../actions/pushNotifications';
import ToastMessage from '../../../common/toast-message';

class PushNotificationsPage extends Component {
  componentWillMount() {
    const {dispatch} = this.props;
    dispatch(getPushNotifications());
  }


  sortNotifications = (column) => {
    const {dispatch} = this.props;
    const mappedColumn = column === 'user-name' ? 'user' : column.replace('-', '_');
    dispatch(getPushNotifications({sort: mappedColumn, direction: 'asc'}));
  };

  toastError = () => toast.error(<ToastMessage iconStyle="error" message="Cannot export push notifications"/>);

  handleExport = () => {
    downloadPushNotifications()
      .then((response) => {
        FileDownload(response.data, `pushes_${(new Date()).getTime()}.csv`);
      })
      .catch(this.toastError);
  };

  render() {
    const {notifications, loading} = this.props;

    return (
      <Grid>
        <Row>
          <Col lg={12}>
            <BackLink href="/"/>
            <PageTitle>Push notifications</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <h2>Notification summary</h2>
            <div className="pull-right">
              <If condition={loading}>
                <Then>
                  <div>Loading push notifications...</div>
                </Then>
                <Else>
                  <div>
                    Displaying <span className="text-bold"> all {notifications.length}</span> push notifications
                  </div>
                </Else>
              </If>
            </div>
            <h2 className="left">
              <Button onClick={this.handleExport}>Export pushes</Button>
            </h2>
            <PushNotificationsTable notifications={notifications} sort={this.sortNotifications}/>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  notifications: state.pushNotifications.notifications,
  loading: state.pushNotifications.fetching && !state.pushNotifications.fetched,
});

export default connect(mapStateToProps)(PushNotificationsPage);



// WEBPACK FOOTER //
// ./src/components/admin/app/push-notifications/push-notifications-page.jsx